import styled from 'styled-components';

export const FilterListDiv = styled.div`
  padding: 10px 0;
`;

export const ShowingResult = styled.h2`
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 70%);
  padding: 10px 0;
  font-size: clamp(15px, 2vw, 16px);
  @media (max-width: 720px) {
    padding: 6px 10px 10px;
  }
`;
